import React, { useEffect, useState } from "react";
import axios from "axios";
import "../../styles/App.css";

const DormitoriesPage = () => {
  const [dormitories, setDormitories] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    address: "",
    floors: 1,
  });
  const [editId, setEditId] = useState(null);
  const [error, setError] = useState("");
  const API = process.env.REACT_APP_API_BASE;

  useEffect(() => {
    fetchDormitories();
  }, []);

  const fetchDormitories = async () => {
    try {
      const res = await axios.get(`${API}/api/admin-dormitories`);
      setDormitories(res.data);
    } catch (err) {
      console.error("Помилка отримання гуртожитків:", err);
    }
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name.trim() || formData.floors < 1) {
      setError("Назва гуртожитку та кількість поверхів обов'язкові!");
      return;
    }

    try {
      if (editId) {
        await axios.put(`${API}/api/admin-dormitories/${editId}`, formData);
      } else {
        await axios.post(`${API}/api/admin-dormitories`, formData);
      }
      fetchDormitories();
      setFormData({ name: "", address: "", floors: 1 });
      setEditId(null);
      setError("");
    } catch (err) {
      console.error("Помилка збереження гуртожитку:", err);
    }
  };

  const handleEdit = (dormitory) => {
    setEditId(dormitory.id);
    setFormData({
      name: dormitory.name,
      address: dormitory.address,
      floors: dormitory.floors,
    });
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Ви впевнені, що хочете видалити гуртожиток?"
    );
    if (!confirmDelete) return;

    try {
      await axios.delete(`${API}/api/admin-dormitories/${id}`);
      fetchDormitories();
    } catch (err) {
      setError(err.response?.data?.error || "Неможливо видалити гуртожиток, є пов’язані записи!");
      console.error("Помилка видалення гуртожитку:", err);
    }
  };

  // Гуртожиток за замовчуванням -- один, завжди обраний: за ним розбираються
  // номери кімнат "106/3" з файлу під час завантаження в систему.
  const handleSetMain = async (dormitory) => {
    if (dormitory.is_main) return;
    try {
      await axios.put(`${API}/api/admin-dormitories/${dormitory.id}/main`, {
        isMain: true,
      });
      fetchDormitories();
    } catch (err) {
      setError("Не вдалося змінити гуртожиток за замовчуванням.");
      console.error("Помилка зміни основного гуртожитку:", err);
    }
  };

  const filteredDormitories = dormitories.filter((d) =>
    d.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="dormitories-page page-container">
      <h3 className="header-content-title">
        Якщо тут пусто - сплив термін JWT-токена, необхідно перезайти в
        обліковий запис.
      </h3>
      <input
        className="search-input"
        type="text"
        placeholder="Пошук за назвою..."
        value={searchTerm}
        onChange={handleSearch}
      />

      <form onSubmit={handleSubmit} className="header-content">
        <input
          className="header-content-input"
          type="text"
          placeholder="Назва"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
        />
        <input
          className="header-content-input"
          type="text"
          placeholder="Адреса"
          value={formData.address}
          onChange={(e) =>
            setFormData({ ...formData, address: e.target.value })
          }
        />
        <input
          className="header-content-input"
          type="number"
          placeholder="Кількість поверхів"
          value={formData.floors}
          onChange={(e) =>
            setFormData({ ...formData, floors: Number(e.target.value) })
          }
        />
        <button type="submit" className="admin-add-button">
          {editId ? "Оновити" : "Додати"}
        </button>
      </form>

      {error && <p className="error">{error}</p>}

      <table className="table">
        <thead>
          <tr>
            <th className="table-header">#</th>
            <th className="table-header">Назва</th>
            <th className="table-header">Адреса</th>
            <th className="table-header">Поверхи</th>
            <th
              className="table-header"
              title="Гуртожиток за замовчуванням: номери кімнат на кшталт 106/3 із файлу рейтингу розбираються за ним"
            >
              За замовчуванням
            </th>
            <th className="table-header">Дії</th>
          </tr>
        </thead>
        <tbody>
          {filteredDormitories.map((dorm, index) => (
            <tr key={dorm.id}>
              <td className="table-content">{index + 1}</td>
              <td className="table-content">{dorm.name}</td>
              <td className="table-content">{dorm.address || "—"}</td>
              <td className="table-content">{dorm.floors}</td>
              <td className="table-content">
                <label>
                  <input
                    type="radio"
                    name="main-dormitory"
                    checked={Boolean(dorm.is_main)}
                    onChange={() => handleSetMain(dorm)}
                    aria-label={`Гуртожиток за замовчуванням: ${dorm.name}`}
                  />
                </label>
              </td>
              <td className="table-content">
                <div className="admin-button-container">
                  <button
                    className="admin-edit-button"
                    onClick={() => handleEdit(dorm)}
                  >
                    ✏️
                  </button>
                  <button
                    className="admin-edit-button"
                    onClick={() => handleDelete(dorm.id)}
                  >
                    🗑️
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DormitoriesPage;
